import { connect } from 'react-redux'
import FieldCheckbox from './FieldCheckbox.js'
import { toggleExportField } from '../../actionCreators'

const mapStateToProps = (state, ownProps) => ({
	checked: state.exportSettings.fields[ownProps.field]
})

const mapDispatchToProps = (dispatch, ownProps) => ({
	onChange: () => dispatch(toggleExportField(ownProps.field))
})

export default connect(mapStateToProps, mapDispatchToProps)(FieldCheckbox);


// WEBPACK FOOTER //
// ./src/components/Export/FieldCheckboxContainer.js